import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';

const clientCodeExlude = ['INVALID_REFRESH', 'CODE_NOT_FOUND']

export const apiInstance = axios.create({
  baseURL: isProduction ? process.env.REACT_APP_URL : 'http://localhost:3001',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

apiInstance.interceptors.response.use(
  (response) => response, // Directly return successful responses.
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry && !clientCodeExlude.includes(error.response.data.clientCode)) {
      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
      try {
        // Make a request to your auth server to refresh the token.
        const response = await apiInstance.post('/auth/refresh');
        const { accessToken } = response.data;

        localStorage.setItem('token', accessToken);

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;

        apiInstance.interceptors.request.clear();

        apiInstance.interceptors.request.use(
          (config) => {
            config.headers.Authorization = `Bearer ${accessToken}`;
            return config;
          },
          (error) => {
            return Promise.reject(error);
          },
        );

        return apiInstance(originalRequest); // Retry the original request with the new access token.
      } catch (refreshError) {
        // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
        console.error('Token refresh failed:', refreshError);
        localStorage.removeItem('token');
        window.location.href = '/sign-in';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error); // For all other errors, return the error as is.
  },
);
